import { Component, HostBinding } from '@angular/core';

@Component({
  selector: 'app-standard-page-content-actions',
  templateUrl: 'standard-page-content-actions.component.html',
  standalone: false,
})
export class StandardPageContentActionsComponent {
  @HostBinding() readonly class = 'card-body card-body-actions flex-grow-0';
}
